import React from 'react';
import { Grain, Letterbox } from './components/ui/BasicUI';
import { useActiveYuga } from './hooks/useActiveYuga';
import { useScrollProgress } from './components/ui/BasicUI';
import { HUD } from './components/ui/HUD';
import { Prologue } from './components/scenes/Prologue';
import { ChapterManu } from './components/scenes/ChapterManu';
import { ChapterRama, YugaTurn } from './components/scenes/ChapterRama';
import { ChapterKrishna } from './components/scenes/ChapterKrishna';
import { Finale } from './components/scenes/Finale';
import { Granthalaya } from './components/scriptures/Granthalaya';
import { ExtrasMount } from './components/extras/ExtrasModals';

function App() {
  const { yuga, chapter } = useActiveYuga();
  const progress = useScrollProgress();

  return (
    <>
      <Letterbox />
      <Grain />
      <HUD yuga={yuga} chapterLabel={chapter} progress={progress} />

      <main className="chronicle">
        <Prologue />
        <ChapterManu />

        <YugaTurn
          dataYuga="treta"
          fromName="Satya"
          toName="Treta"
          line="The first quarter of dharma fell away like a leaf. The mountains forgot the names they had been given. A new age began, and a child was born who would remember the old ones."
        />

        <ChapterRama />

        <YugaTurn
          dataYuga="dvapara"
          fromName="Treta"
          toName="Dvapara"
          line="Another quarter slipped. Truth now stood on two legs. The world grew clever — and the gods, hearing the cleverness, prepared to walk among us once more."
        />

        <ChapterKrishna />

        <Finale />

        <footer className="footer">
          <div className="om">ॐ शान्तिः शान्तिः शान्तिः</div>
          <div className="credit">Sanatana Chronicles · Manu → Kalki · a living telling</div>
        </footer>
      </main>

      <Granthalaya />
      <ExtrasMount />
    </>
  );
}

export default App;
